export const SCALE_FACTOR = 2;
export const UPLOAD_IMAGE_PATH = `${process.env.PUBLIC_URL}/uploadImage`;
export const PRESET_IMAGE_PATH = `${process.env.PUBLIC_URL}/presetImage`;
export const PUBLIC_URL = `${process.env.PUBLIC_URL}`;
